import {get, post, remove,put} from "./../api_helper"
import * as url from "./../url_helper";

const baseURL = process.env.REACT_APP_API_DOTNET_URL;

export const getSalaryInrement = ({HrControl, employeeID}) => get(`${baseURL + url.SALARY_INCRMENT_GETINFO}/${HrControl}?employeeID=${employeeID}`);
export const getAuditTrail = ( employeeID) => get(`${baseURL + url.AUDIT_TRAIL}?ActnNo=${employeeID}`);
export const getTransaction = ( employeeID) => get(`${baseURL + url.TRANSACTION}/${employeeID}`);
export const updatesalaryapiUrl = ( payload) => post(`${baseURL + url.SALARY_INCRMENT_UPDATE}`, payload);
